import { INVITE_PARENTS_ROUTE } from "features/teachers/common/components/InviteClassesParentsModal/InviteClassesParentsModal";

import { linkToTeacherDashboard } from "../../links";

export function linkToTeacherHomepage() {
  return `${linkToTeacherDashboard()}/home`;
}

export function linkToTeacherFeedback() {
  return `${linkToTeacherHomepage()}/feedback`;
}

export function linkToInviteParentsInfoModal() {
  return `${linkToTeacherHomepage()}/${INVITE_PARENTS_ROUTE}`;
}

export function linkToMiSInfoModal() {
  return `${linkToTeacherHomepage()}/mis-sync-info`;
}
